module.exports = __webpack_public_path__ + "static/media/logo-sm-elite.4cb1c0bb.png";